import {DayjsMeta} from "@/decorators/decorators";
import {ApiResource} from "@/models/base/ApiResource";
import {Dayjs} from "dayjs";

export class ApiResourceWithDates extends ApiResource {
    @DayjsMeta() createdDate?: Dayjs;
    @DayjsMeta() modifiedDate?: Dayjs;
}